import React from 'react';

const WidgetCard = (props) => {
    return (
        <div 
            className='advertisement-card'
            style={{width: '415px', position: 'relative', overflow: 'hidden'}}
        >
            <div>
                <h4>{props.title}</h4>
                <p>{props.body}</p>
                <a href={props.link}>{props.linkText}</a>
            </div>
            <div style={{
                background: props.color, 
                height: '191px', 
                width: '285px', 
                position: 'absolute', 
                right: '-86px', 
                top: 0, 
                transform: 'rotate(-50deg)'
            }}>
            </div>
            <img className="ad-image" src={props.imgSrc}/> 
        </div>
    );
};

WidgetCard.propTypes = {
    title: React.PropTypes.string,
    body: React.PropTypes.string,
    linkText: React.PropTypes.string,
    link: React.PropTypes.string,
    color: React.PropTypes.string,
    imgSrc: React.PropTypes.string,
};

export default WidgetCard;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/WidgetCard/AdCard.js
 **/